"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipelineVelocityReport = void 0;
var react_1 = __importStar(require("react"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var Types_1 = require("Reports/Types");
var GetPeriodGranularity_1 = require("Reports/Utils/GetPeriodGranularity");
var FunnelAndStatus_1 = require("./FunnelAndStatus");
var UsePipelineReportsData_1 = require("./UsePipelineReportsData");
var VelocityOverview_1 = require("./VelocityOverview");
var HistoryChartView_1 = require("./HistoryChartView");
var VelocityHistoryFilter_1 = require("./VelocityHistoryFilter");
var VelocityHistoryChart_1 = require("./VelocityHistoryChart");
var StatusHistoryFilter_1 = require("./StatusHistoryFilter");
var StatusHistoryChart_1 = require("./StatusHistoryChart");
var IconSpinner_1 = __importDefault(require("@CommonFrontend/IconSpinner/IconSpinner"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var UpgradeBanner_1 = require("Common/Upgrade/UpgradeBanner");
var PageCount_1 = require("Reports/Utils/PageCount");
var ChartExampleData_1 = require("Reports/Utils/ChartExampleData");
var ExampleDataComponents_1 = require("./ExampleDataComponents");
var CalculateTimePeriod_1 = require("Reports/Utils/CalculateTimePeriod");
var inversify_react_1 = require("inversify-react");
var AccountTelemetryHelper_1 = require("@CommonFrontendBackend/Telemetry/AccountTelemetryHelper");
var Util_1 = require("@CommonFrontendBackend/Permissions/Util");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var c = (0, BemBuilder_1.default)("pipeline-velocity-report");
var PipelineVelocityReport = function (_a) {
    var _b, _c;
    var apiBaseUrl = _a.apiBaseUrl, selectedOwner = _a.selectedOwner, currentPageFilter = _a.currentPageFilter, selectedTimePeriod = _a.selectedTimePeriod, selectedCurrency = _a.selectedCurrency, telemetry = _a.telemetry, cleanupFilters = _a.cleanupFilters, selectedPageCollection = _a.selectedPageCollection;
    var granularity = (0, GetPeriodGranularity_1.getPeriodGranularity)(selectedTimePeriod);
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var user = (0, inversify_react_1.useInjection)("user");
    var account = (0, inversify_react_1.useInjection)("account");
    var accountEventProps = (0, AccountTelemetryHelper_1.buildAccountEventProperties)(account, account.plan);
    var _d = (0, CalculateTimePeriod_1.calculateTimePeriod)(selectedTimePeriod), currentPeriodStart = _d.periodStart, currentPeriodEnd = _d.periodEnd;
    var historicalPeriodStart = (0, CalculateTimePeriod_1.calculateTimePeriod)(selectedTimePeriod, Types_1.DEFAULT_HISTORY_SIZE_MAPPING[granularity]).periodStart;
    var timezone = selectedTimePeriod.timezone;
    var commonParams = {
        apiBaseUrl: apiBaseUrl,
        selectedOwner: selectedOwner,
        currentPageFilter: currentPageFilter,
        timezone: timezone,
        granularity: granularity,
        currency: selectedCurrency,
        cleanupFilters: cleanupFilters,
        dataset: "page-velocity-history",
    };
    var _e = (0, UsePipelineReportsData_1.usePipelineReportsData)(__assign(__assign({}, commonParams), { periodStart: currentPeriodStart, periodEnd: currentPeriodEnd })), currentPeriodData = _e.data, currentPeriodError = _e.error;
    var _f = (0, UsePipelineReportsData_1.usePipelineReportsData)(__assign(__assign({}, commonParams), { periodStart: historicalPeriodStart, periodEnd: currentPeriodStart })), historicalData = _f.data, historicalDataError = _f.error;
    var entireHistory = currentPeriodData && historicalData ? __spreadArray(__spreadArray([], __read(historicalData), false), __read(currentPeriodData), false) : undefined;
    var status = getChartDataStatus(entireHistory, !!currentPeriodError || !!historicalDataError);
    var historyChartData = status === "nodata" ? ChartExampleData_1.chartExampleData : entireHistory;
    var currentPeriodStatus = getChartDataStatus(currentPeriodData, !!currentPeriodError);
    var currentVelocityMetric;
    if (currentPeriodStatus === "nodata") {
        currentVelocityMetric = ChartExampleData_1.chartExampleData[ChartExampleData_1.chartExampleData.length - 1];
    }
    else {
        currentVelocityMetric = currentPeriodData ? currentPeriodData[0] : undefined;
    }
    var previousVelocityMetric = historyChartData
        ? historyChartData[historyChartData.length - 2]
        : undefined;
    var _g = (currentVelocityMetric === null || currentVelocityMetric === void 0 ? void 0 : currentVelocityMetric.metrics) || {}, pageStatusMetrics = _g.pageStatusMetrics, pageVelocity = _g.pageVelocity;
    var firePipelineTelemetry = function (actionType) {
        telemetry.track(Types_1.ReportTelemetryEventName.PipelineReportAction, {
            action_type: actionType,
        }, { blockIntercom: true });
    };
    (0, react_1.useEffect)(function () {
        var lastEdited = cleanupFilters.lastEdited;
        if (entireHistory && entireHistory.length > 0) {
            var sendTelemetry = function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, serverTelemetry.sendReportViewedTelemetry({
                                commonProperties: {
                                    eventOrigin: event_tracker_types_1.EventOrigin.Report,
                                    qwilrAppDayNumber: (0, AccountTelemetryHelper_1.calculateQwilrAppDayNumber)(user.createdAt),
                                },
                                userDetails: {
                                    anonymousId: null,
                                    userId: user._id,
                                    hasQwilrAccount: true,
                                    userRole: (0, Util_1.isAdmin)(user) ? "admin" : "creator",
                                },
                                accountDetails: {
                                    accountId: account._id,
                                    accountApp: event_tracker_types_1.AccountApp.Qwilr,
                                    isTrialPlan: accountEventProps.account_is_trial_plan,
                                    isTrialActive: accountEventProps.account_is_trial_active,
                                    additionalSeats: accountEventProps.account_seats_additional,
                                    usersEnabled: accountEventProps.account_users_enabled,
                                    accountPlanInterval: accountEventProps.account_plan_interval,
                                    accountIsCustomAgreement: account.hasCustomPlanAgreement,
                                    accountSeatsMinimum: account.minimumSeats || 0,
                                },
                                planDetails: {
                                    planId: account.plan._id,
                                    planLevel: accountEventProps.account_plan_level,
                                    planName: accountEventProps.account_plan_name,
                                    planSeats: accountEventProps.account_seats_plan,
                                    stripePlanPrice: accountEventProps.stripe_plan_price,
                                },
                                eventProperties: {
                                    reportName: "pipeline",
                                    reportFilterPeriod: selectedTimePeriod.timePeriod,
                                    reportFilterIdentityType: selectedOwner.ownerType,
                                    reportFilterCurrency: selectedCurrency.toLowerCase(),
                                    reportFilterCollection: selectedPageCollection === null || selectedPageCollection === void 0 ? void 0 : selectedPageCollection.name,
                                    reportFilterTemplates: currentPageFilter === null || currentPageFilter === void 0 ? void 0 : currentPageFilter.templateIds.join(", "),
                                    reportFilterTags: currentPageFilter === null || currentPageFilter === void 0 ? void 0 : currentPageFilter.tags.join(", "),
                                    reportFilterIncludedContent: Types_1.includedPagesTypeTelemetryMapping[currentPageFilter.pageWith],
                                    reportFilterLastEdited: lastEdited.enabled ? lastEdited.lastEditedDays : undefined,
                                    reportViewedPageCountSelected: (0, PageCount_1.getPageCount)(entireHistory[historyChartData.length - 1]),
                                    reportViewedPageCountHistory: entireHistory.reduce(function (historyTotal, period) { return historyTotal + (0, PageCount_1.getPageCount)(period); }, 0),
                                },
                                segmentIntegrations: { Intercom: false },
                            })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            sendTelemetry();
        }
    }, [entireHistory]);
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement(ExampleDataComponents_1.ExampleDataDialogueMobile, { enabled: status === "nodata" }),
        react_1.default.createElement(StatusContainer, { status: currentPeriodStatus, spinnerText: "Generating funnel and status chart" },
            react_1.default.createElement("div", { className: "".concat(c("top-section"), " ").concat(currentPeriodStatus) },
                react_1.default.createElement("div", { className: "".concat(c("funnel-and-status-layout"), " ").concat(currentPeriodStatus) },
                    react_1.default.createElement(ExampleDataComponents_1.ExampleDataOverlay, { enabled: currentPeriodStatus === "nodata" }),
                    react_1.default.createElement(FunnelAndStatus_1.FunnelAndStatus, { pageStatusMetrics: pageStatusMetrics, pageVelocity: pageVelocity, selectedCurrency: selectedCurrency, firePipelineTelemetry: firePipelineTelemetry })),
                react_1.default.createElement("div", { className: "".concat(c("velocity-layout"), " ").concat(currentPeriodStatus) },
                    react_1.default.createElement(ExampleDataComponents_1.ExampleDataOverlay, { enabled: currentPeriodStatus === "nodata" }),
                    react_1.default.createElement(VelocityOverview_1.VelocityOverview, { selectedCurrency: selectedCurrency, pageVelocity: __assign(__assign({}, pageVelocity), { averageTimeLive: (_b = pageVelocity === null || pageVelocity === void 0 ? void 0 : pageVelocity.pageCycleTimes) === null || _b === void 0 ? void 0 : _b.averageClose }), previousPageVelocity: (_c = previousVelocityMetric === null || previousVelocityMetric === void 0 ? void 0 : previousVelocityMetric.metrics) === null || _c === void 0 ? void 0 : _c.pageVelocity, firePipelineTelemetry: firePipelineTelemetry })),
                react_1.default.createElement(ExampleDataComponents_1.ExampleDataDialogue, { enabled: currentPeriodStatus === "nodata" }))),
        react_1.default.createElement(StatusContainer, { status: status, spinnerText: "Generating sales velocity history" },
            react_1.default.createElement("div", { className: "".concat(c("trends-layout"), " ").concat(status) },
                react_1.default.createElement(ExampleDataComponents_1.ExampleDataOverlay, { enabled: status === "nodata" }),
                react_1.default.createElement(HistoryChartView_1.HistoryChartView, { title: "Sales velocity history", granularity: granularity, data: historyChartData, selectedCurrency: selectedCurrency, selectedTimePeriod: selectedTimePeriod, FilterComponent: VelocityHistoryFilter_1.VelocityHistoryFilter, ChartComponent: VelocityHistoryChart_1.VelocityHistoryChart, firePipelineTelemetry: firePipelineTelemetry }),
                react_1.default.createElement(ExampleDataComponents_1.ExampleDataDialogue, { enabled: status === "nodata" }))),
        react_1.default.createElement(UpgradeBanner_1.DismissibleUpgradeBanner, { className: c("upsell-prompt"), promptId: PromptTypes_1.PromptId.AnalyticsReportUpsell, telemetryOrigin: "pipeline_report_history_inline" }),
        react_1.default.createElement(StatusContainer, { status: status, spinnerText: "Generating pipeline status history" },
            react_1.default.createElement("div", { className: "".concat(c("trends-layout"), " ").concat(status) },
                react_1.default.createElement(ExampleDataComponents_1.ExampleDataOverlay, { enabled: status === "nodata" }),
                react_1.default.createElement(HistoryChartView_1.HistoryChartView, { title: "Pipeline status history", data: historyChartData, granularity: granularity, selectedCurrency: selectedCurrency, selectedTimePeriod: selectedTimePeriod, FilterComponent: StatusHistoryFilter_1.StatusHistoryFilter, ChartComponent: StatusHistoryChart_1.StatusHistoryChart, firePipelineTelemetry: firePipelineTelemetry }),
                react_1.default.createElement(ExampleDataComponents_1.ExampleDataDialogue, { enabled: status === "nodata" })))));
};
exports.PipelineVelocityReport = PipelineVelocityReport;
function StatusContainer(_a) {
    var status = _a.status, spinnerText = _a.spinnerText, children = _a.children;
    var StatusComponent = null;
    if (status === "fetching") {
        StatusComponent = (react_1.default.createElement("div", { className: c("status-layout", status) },
            react_1.default.createElement(IconSpinner_1.default, { icon: icons_1.Analytics, text: spinnerText })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        StatusComponent,
        children));
}
function getChartDataStatus(data, isError) {
    if (isError) {
        return "error";
    }
    else if (data == undefined) {
        return "fetching";
    }
    else if (data.length === 0) {
        return "nodata";
    }
    else {
        return "fetched";
    }
}
